


























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';

import { getAgoString } from '@/utils/general';

@Component
export default class MacroCard extends Vue {
	@State private launcherState !: any;
	@State private storeInputText !: any;

	@Action private deleteActionitem!: any;
	@Action private goTo!: any;

	@Prop() private item !: any;

	private get name() {
		if (this.launcherState === 'INPUT') {
			return this.storeInputText;
		} else {
			return this.item.name;		
		}
	}

	// private get url() {
	// 	if (this.item.args) {
	// 		return this.item.args.url;
	// 	} else {
	// 		return document.location.href;
	// 	}
	// }

	private get description() {
		if (this.item.props) {
			return this.item.props.props.description;
		} else {
			return null;
		} 
	}

	private get createdAt() {
		if (this.item.props) {
			return getAgoString(this.item.props.created_at);
		} else {
			return null;
		} 
	}

	private get inputVars() {
		if (this.item.args) {
			return this.item.args.inputVars.join(', ');
		} else {
			return null;
		} 
	}

	private get outputVars() {
		if (this.item.args) {
			return this.item.args.outputVars.join(', ');
		} else {
			return null;
		} 
	}

	private get timesUsed() {
		if (this.item.props) {
			return this.item.props.timesUsed;
		} else {
			return null;
		}
	}

	private async deleteActionitem_() {
		await this.deleteActionitem(this.item.id);
	}
}

